export default __webpack_public_path__ + "static/media/decor.d657f47b.svg";